import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ButtonLineComponent, DialogModule, FieldComponent, GroupComponent } from '@bas/ui';
import { Button } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { ButtonModule } from '../shared/elements/button/button.module';
import { MsgKeyModule } from '../shared/translate/msg-key.module';
import { AdblockDialogComponent } from './adblock-dialog.component';
import { AdblockService } from './adblock.service';

@NgModule({
	imports: [
		MatDialogModule,
		ButtonModule,
		MsgKeyModule,
		DialogModule,
		ButtonModule,
		GroupComponent,
		FieldComponent,
		ButtonLineComponent,
		Button,
	],
	declarations: [
		AdblockDialogComponent,
	],
	providers: [
		AdblockService,
		DialogService,
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AdblockModule {}
